<template>
    <div v-if="client">
        <!-- google analytics id -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Google analytics id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.analytics.googleAnalyticsId"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- google recaptcha key -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Google recaptcha key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.analytics.googleRecaptchaKey"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- yandex metrika key -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Yandex metrika key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.analytics.yandexMetrikaKey"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

export default {
    name: 'client-settings-view-analytics',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/analytics.vue